// import React from 'react';
// import ReactDOM from 'react-dom/client';
// import './index.css';
// import App from './App';
// import Tweet from './Tweet';
// import Art from './Art';
// import akm from './cover.png';
// import Contact from './Contact';
// import reportWebVitals from './reportWebVitals';

// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <React.StrictMode>
// <nav className="Global-nav">
//         <header className="App-header">
//                   <img className="App-logo" alt="DR AK MEHTA IAS(R)" src={akm}/>
//                   <br/>
//                     <h1>Dr AK Mehta IAS(R)</h1>
//                   </header>
//         <ul className="Nav-list"> 
//         <li><a href="#about">About  </a></li>
//         <li><a href="#articles">Articles</a></li>
//         <li><a href="#media">Media</a></li>
//         <li><a href="#contact">Contact</a></li>
//       </ul>
//     </nav>

//     <section id="about">
//       <App />
//     </section>

//     <section id="articles">
//       <Art />
//     </section>

//     <section id="media">
//       <Tweet />
//     </section>
//         <section id="contact">
//       <Contact />
//     </section>
//   </React.StrictMode>
// );

// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
// import React, { useState } from "react";
// import ReactDOM from "react-dom/client";
// import "./index.css";
// import App from "./App";
// import Tweet from "./Tweet";
// import Art from "./Art";
// import Contact from "./Contact";
// import akm from "./cover.png";

// function Website() {
//   const [activeSection, setActiveSection] = useState("about");

//   return (
//     <>
//       <nav className="Global-nav">
//         <header className="App-header">
//           <img
//             className="App-logo"
//             alt="DR AK MEHTA IAS(R)"
//             src={akm}
//           />
//           <h1>Dr AK Mehta IAS(R)</h1>
//         </header>

//         <ul className="Nav-list">
//           <li>
//             <button onClick={() => setActiveSection("about")}>
//               About
//             </button>
//           </li>
//           <li>
//             <button onClick={() => setActiveSection("articles")}>
//               Articles
//             </button>
//           </li>
//           <li>
//             <button onClick={() => setActiveSection("media")}>
//               Media
//             </button>
//           </li>
//           <li>
//             <button onClick={() => setActiveSection("contact")}>
//               Contact
//             </button>
//           </li>
//         </ul>
//       </nav>

//       {activeSection === "about" && (
//         <section id="about">
//           <App />
//         </section>
//       )}

//       {activeSection === "articles" && (
//         <section id="articles">
//           <Art />
//         </section>
//       )}

//       {activeSection === "media" && (
//         <section id="media">
//           <Tweet />
//         </section>
//       )}

//       {/* {activeSection === "contact" && ( */}
//         <section id="contact">
//           <Contact />
//         </section>
//       {/* )} */}
//     </>
//   );
// }

// const root = ReactDOM.createRoot(document.getElementById("root"));
// root.render(
//   <React.StrictMode>
//     <Website />
//   </React.StrictMode>
// );

import React, { useState } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";

import App from "./App";
import Tweet from "./Tweet";
import Art from "./Art";
import Contact from "./Contact";
import akm from "./cover.png";

function Website() {
  const [activeSection, setActiveSection] = useState("about");

  return (
    <>
      <nav className="Global-nav">
        <header className="App-header">
          <img
            className="App-logo"
            alt="DR AK MEHTA IAS(R)"
            src={akm}
          />
          <h1>Dr AK Mehta IAS(R)</h1>
        </header>

        <ul className="Nav-list">
          <li>
            <a
              href="#about"
              onClick={(e) => {
                e.preventDefault();
                setActiveSection("about");
              }}
            >
              About
            </a>
          </li>

          <li>
            <a
              href="#articles"
              onClick={(e) => {
                e.preventDefault();
                setActiveSection("articles");
              }}
            >
              Articles
            </a>
          </li>

          <li>
            <a
              href="#media"
              onClick={(e) => {
                e.preventDefault();
                setActiveSection("media");
              }}
            >
              Media
            </a>
          </li>

          <li>
            <a
              href="#contact"
              onClick={(e) => {
                e.preventDefault();
                setActiveSection("contact");
              }}
            >
              Contact
            </a>
          </li>
        </ul>
      </nav>

      {activeSection === "about" && (
        <section id="about">
          <App />
        </section>
      )}

      {activeSection === "articles" && (
        <section id="articles">
          <Art />
        </section>
      )}

      {activeSection === "media" && (
        <section id="media">
          <Tweet />
        </section>
      )}

      {activeSection === "contact" && (
        <section id="contact">
          <Contact />
        </section>
      )}
    </>
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Website />
  </React.StrictMode>
);